import { ManagerPermissionEnum } from './auth';
import { ApiResponseType } from './api';

export enum EmployeeJoinStatusEnum {
    pending,
    joined,
    deleted,
}

export type EmployeeFormType = {
    firstName: string;
    middleName: string;
    lastName: string;
    email: string;
    permissionTypeList: ManagerPermissionEnum[];
};

export type EmployeeType = {
    id: string;
    firstName: string;
    middleName: string;
    lastName: string;
    email: string;
    permissionTypeList: ManagerPermissionEnum[];
    dateAdded: Date;
    joinStatus: number;
};

export type EmployeeListResponseType = Omit<ApiResponseType, 'resultObject'> & {
    resultObject: {
        items: EmployeeType[];
        hasMore: boolean;
        count: number;
    };
};

export type EmployeeCreateResponseType = Omit<ApiResponseType, 'resultObject'> & {
    resultObject: {
        value: string;
    };
};
export type EmployeeRolesListResponseType = Omit<ApiResponseType, 'resultObject'> & {
    resultObject: {
        items: EmployeeRolesType[];
        hasMore: boolean;
        count: number;
    };
};
export type EmployeeRolesType = {
    id: string;
    avatarUrl: string;
    firstName: string;
    middleName: string;
    lastName: string;
    email: string;
    isOwnAccount: boolean;
    isOwner: boolean;
    isAdmin: boolean;
    isOfferManager: boolean;
};

export type EmployeeRolesFormType = {
    OfferXAdminEmail: string;
    id: string;
    PermissionType: ManagerPermissionEnum;
    PermissionTypeChecked: boolean;
};
export type EmployeeRolesEmailType = {
    OfferXAdminEmail: string;
};
export interface ScreenxEmployeeRolesListResponseType {
    companyUsers: CompanyUser[];
    allRoles: Role[];
    totalRecords: number;
}

export interface CompanyUser {
    companyUserId: number;
    companyId: number;
    company: any;
    userId: number;
    firstName: string;
    lastName: string;
    name: string;
    email: string;
    appTimeZone: any;
    roles: Role[];
    rolesJSON: string;
    existingRoles: any[];
    isActive: boolean;
    userImageBlobName: any;
    accountTypeId: number;
    website: any;
    workTitle: any;
    passwordHash: any;
    salt: any;
}

export interface Role {
    roleId: number;
    roleName: string;
}

export interface ScreenXUserRoles {
    userRoles: Role[];
}

export interface ScreenXResponse {
    result: any;
    statusCode: number;
}
